import { DeviceEnabledType, TurfUtils, UserAttributeDefs } from '@iotv/datamodel-core'
import { PathDirection, Position, ValidBusinessObject } from '@iotv/iotv-v3-types'

const { isInArea, convertPointToTurfPosition, getThingInArea } = TurfUtils

const debug = process.env.REACT_APP_DEBUG && false

const typeName = 'AssetTracker'

export type AssetTrackerProps = {
  name?: string
  lastKnownPosition?: Position
  batteryVoltage?: number
  batteryPercentage: number | null
  deviceActive?: boolean
  deviceInactiveSince?: number
}

export class AssetTracker extends DeviceEnabledType implements AssetTrackerProps, ValidBusinessObject {
  constructor(ob: any) {
    super(typeName, ob)
    this.batteryPercentage = ob.batteryPercentage || null
  }
  name?: string
  lastKnownPosition?: Position
  batteryVoltage?: number
  batteryPercentage: number | null
  deviceActive?: boolean
  deviceInactiveSince?: number

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'identification',
        validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
      },

      Device: {
        type: 'RelatedType',
        editable: false,
        label: 'Device',
        objectTypeId: 'Device',
        description: 'Device',
        direction: PathDirection.child,
      },
    }
  }

  getLinkAttributes() {
    const functions = this.getUserAttributes().functions
    return {
      ...super.getLinkAttributes(),
      functions,
    }
  }
}
